import { unsafeUniformIntDistribution, xoroshiro128plus } from "pure-rand";

const SEEDED_RANDOM_MODULUS = 2147483647;
const SEEDED_RANDOM_UNIT_SCALE = 1000000000;

/**
 * Creates a deterministic random number generator that returns values in the range [0, 1).
 *
 * @param seed String seed material, normally a UUID.
 * @returns Function that returns the next deterministic pseudo-random value.
 */
export function createSeededRandomNumberGenerator(seed: string): () => number {
    const randomGenerator = xoroshiro128plus(hashSeed(seed));

    return () => unsafeUniformIntDistribution(0, SEEDED_RANDOM_UNIT_SCALE - 1, randomGenerator) / SEEDED_RANDOM_UNIT_SCALE;
}

/**
 * Converts arbitrary seed text into a positive numeric seed for pure-rand.
 *
 * @param seed String seed material.
 * @returns Numeric seed in the generator's supported range.
 */
export function hashSeed(seed: string): number {
    let hash = 0;

    for (let index = 0; index < seed.length; index += 1) {
        hash = (hash * 31 + seed.charCodeAt(index)) % SEEDED_RANDOM_MODULUS;
    }

    return hash || 1;
}
